import React, { useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

const QrScanner = ({ onScanSuccess }) => {
  const scannerRef = useRef(null);
  const html5QrCodeRef = useRef(null);

  useEffect(() => {
    if (!scannerRef.current) return;

    const qrCodeRegionId = "qr-reader";
    html5QrCodeRef.current = new Html5Qrcode(qrCodeRegionId);

    const config = { fps: 10, qrbox: 250 };

    html5QrCodeRef.current
      .start(
        { facingMode: "environment" }, // Cámara trasera
        config,
        (decodedText) => {
          onScanSuccess(decodedText);
          html5QrCodeRef.current.stop().then(() => {
            console.log("Escaneo detenido");
          });
        },
        (errorMessage) => {
          // Puedes mostrar errores si quieres
          console.log("Escaneo fallido: ", errorMessage);
        }
      )
      .catch((err) => console.error("Error al iniciar el escáner:", err));

    return () => {
      html5QrCodeRef.current?.stop().then(() => {
        html5QrCodeRef.current?.clear();
      });
    };
  }, []);

  return (
    <div ref={scannerRef}>
      <div id="qr-reader" style={{ width: "100%" }} />
    </div>
  );
};

export default QrScanner;
